<!-- 热区图片 -->
<template>
    <div v-if="new_data.content.imgList !== undefined">
        <div v-if="new_data.content.style_id == 0">
            <div :style="`width: 100%;`">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 1" :style="`display: flex;`">
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 66.666%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[1].picview"/>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 2" :style="`display: flex;`">
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 66.666%;`">
                <div class="h130"
                    :style="`width: 100%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[1].picview"/>
                </div>
                <div class="h130"
                    :style="`width: 100%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[2].picview"/>
                </div>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 3" id="parentId" :style="`display: flex;`">
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 66.666%;`">
                <div class="h130"
                    :style="`width: 100%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[1].picview"/>
                </div>
                <div class="display_flex">
                    <div class="h130"
                        :style="`width: 50%;`"
                    >
                        <img class="wh100" :src="new_data.content.imgList[2].picview"/>
                    </div>
                    <div class="h130"
                        :style="`width: 50%;`"
                    >
                        <img class="wh100" :src="new_data.content.imgList[3].picview"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 4" :style="`display: flex;`">
            <div :style="`width: 50%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 50%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[1].picview"/>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 5" :style="`display: flex;`">
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[1].picview"/>
            </div>
            <div :style="`width: 33.333%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[2].picview"/>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 6" :style="`display: flex;`">
            <div :style="`width: 25%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[0].picview"/>
            </div>
            <div :style="`width: 25%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[1].picview"/>
            </div>
            <div :style="`width: 25%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[2].picview"/>
            </div>
            <div :style="`width: 25%;`" class="h260">
                <img class="wh100" :src="new_data.content.imgList[3].picview"/>
            </div>
        </div>
        <div v-if="new_data.content.style_id == 7">
            <div
                :style="`width: 100%;display: flex;`"
            >
                <div class="h130"
                    :style="`width: 50%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[0].picview"/>
                </div>
                <div class="h130"
                    :style="`width: 50%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[1].picview"/>
                </div>
            </div>
            <div
                :style="`width: 100%;display: flex`"
            >
                <div class="h130"
                    :style="`width: 50%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[2].picview"/>
                </div>
                <div class="h130"
                    :style="`width: 50%;`"
                >
                    <img class="wh100" :src="new_data.content.imgList[3].picview"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        new_data: {
            typeof: Object,
            default: {},
        },
    },
    mounted() {
    },
};
</script>

<style scoped>
.display_flex {
    display: flex;
}
.wh100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.h260 {
    height: 260px;
}
.h130 {
    height: 130px;
}
</style>